export const environment = {
    production: false,
    enableSentry: true,
    enablePendo: true,
    sentry: {
        dsn: 'https://f9b83aff0f328dd1f95a99a3ccbb6793@o4510155888263168.ingest.us.sentry.io/4510157809909760',
        environment: 'development'
    },
    apiUrl: 'https://leap-api.dev.appliedparticle.io:443/api',
    baseUrl: 'https://leap-api.dev.appliedparticle.io:443',
    /* Blob-storage / CDN hosts serving KML floorplans and dust maps. Fetched
       without credentials, so an entry here does not expose the access token. */
    kmlTrustedOrigins: ['https://d2ngrkmiyoydcn.cloudfront.net', 'https://d2qnmse3rg5opb.cloudfront.net'] as string[],
    googleClientId: '225469206148-kiq50uos8534la7siapv4vpiiq7uso70.apps.googleusercontent.com',
    microsoft: {
      client_id: '0206bdbc-7f3c-4a7b-b6f3-ddff2adf2750',
      authority : 'https://login.microsoftonline.com/organizations',
      redirectUri : 'https://leap.dev.appliedparticle.io'
    },
    googleMapsKey: 'AIzaSyBWobSTKrK52JCiL0eNqonS70wNjAL1LFo',
    mapTileProvider: 'openstreetmap' as const,
  };
